<template>
  <div class="animate-pulse flex flex-col gap-y-3">
    <table class="w-full table-auto border-collapse border text-sans">
      <thead>
        <tr class="py-2 ps-3 border border-brand-gray-300 text-start">
          <th colspan="4" class="text-xs py-2 px-3 border border-brand-gray-300 text-start">
            <div class="my-0.5 w-full bg-gray-100 h-4 rounded"></div>
            <div class="my-0.5 w-3/4 bg-gray-100 h-4 rounded"></div>
          </th>
        </tr>
        <tr>
          <td class="p-1 border border-gray-100">
            <div class="w-full bg-gray-100 h-4 rounded"></div>
          </td>
          <td class="p-1 border border-gray-100">
            <div class="w-full bg-gray-100 h-4 rounded"></div>
          </td>
          <td class="p-1 border border-gray-100">
            <div class="w-full bg-gray-100 h-4 rounded"></div>
          </td>
          <td class="p-1 border border-gray-100">
            <div class="w-full bg-gray-100 h-4 rounded"></div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr :key="key" v-for="key in [1, 2, 3, 4]">
          <td class="p-1 border border-gray-100">
            <div class="w-2/4 bg-gray-100 h-4 rounded"></div>
          </td>
          <td class="p-1 border border-gray-100">
            <div class="w-3/4 bg-gray-100 h-4 rounded"></div>
          </td>
          <td class="p-1 border border-gray-100">
            <div class="w-2/4 bg-gray-100 h-4 rounded"></div>
          </td>
          <td class="p-1 border border-gray-100">
            <div class="w-3/4 bg-gray-100 h-4 rounded"></div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="flex flex-col rounded gap-y-3">
      <div class="w-full flex flex-col gap-y-1">
        <div class="w-3/4 bg-gray-100 h-4 rounded"></div>
        <div class="w-8/12 bg-gray-100 h-4 rounded"></div>
      </div>
    </div>
    <div class="flex flex-col rounded gap-y-3">
      <div class="flex gap-x-2">
        <div class="bg-gray-100 w-32 h-32 aspect-square rounded"></div>
        <div class="bg-gray-100 w-32 h-32 aspect-square rounded"></div>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
